define.alias("shared/components/shared/ui/accordion", "calendar/components/shared/ui/accordion");